import apiClient from '../utils/apiClient';

// Definitions for one entity ('lead' | 'project'), ordered for display.
// Omit entityType to get every field with its applies_to list (settings view).
export async function getCustomFields(entityType) {
  const response = await apiClient.get('/api/custom-fields', {
    params: entityType ? { entity_type: entityType } : {},
  });
  return response.data;
}

export async function createCustomField(field) {
  const response = await apiClient.post('/api/custom-fields', field);
  return response.data;
}

export async function updateCustomField(fieldId, field) {
  const response = await apiClient.put(`/api/custom-fields/${fieldId}`, field);
  return response.data;
}

export async function deleteCustomField(fieldId) {
  const response = await apiClient.delete(`/api/custom-fields/${fieldId}`);
  return response.data;
}

export async function reorderCustomFields(entityType, fieldIds) {
  const response = await apiClient.put('/api/custom-fields/reorder', {
    entity_type: entityType,
    fieldIds,
  });
  return response.data;
}
